import { CheckFilledIcon } from '@/components/Icons';
import { useDimensions } from '@/hooks/useDimensions';
import { cn } from '@/utils';
import React from 'react';
import { create } from 'zustand';
import PlanFeatures from '../Planfutures';

export const useTabsStore = create<{
  activeTab: string;
  setActiveTab: (tab: string) => void;
}>((set) => ({
  activeTab: 'monthly',
  setActiveTab: (tab) => set({ activeTab: tab }),
}));

const TabsTrigger = ({
  tabKey,
  children,
}: {
  tabKey: string;
  children: React.ReactNode;
}) => {
  const { activeTab, setActiveTab } = useTabsStore();
  return (
    <button
      className={`
        px-[32px] py-[16px] text-[14px] font-medium transition-colors font-pressura-mono
        ${activeTab === tabKey
          ? 'bg-jen-content-primary text-jen-content-primary-contrast rounded-md'
          : 'bg-transparent'
        }
      `}
      onClick={() => setActiveTab(tabKey)}
    >
      {children}
    </button>
  );
};

const TabsContent = ({
  value,
  children,
}: {
  value: string;
  children: React.ReactNode;
}) => {
  const { activeTab } = useTabsStore();

  return <>{value === activeTab && <div className="py-6">{children}</div>}</>;
};
interface planListType {
  key: string;
  price: string;
  desc: string[];
  icon: React.JSX.Element;
  button: React.JSX.Element;
  name: string;
}

const ChargeTabs = ({ }: {}) => {
  const { isMobileOrPad } = useDimensions();
  return (
    <div className="rounded-t-lg w-full mt-[24px]">
      <div className="w-fit flex border border-jen-border rounded-lg bg-jen-background-secondary">
        <TabsTrigger tabKey="monthly">MONTHLY</TabsTrigger>
        {/* <TabsTrigger tabKey="yearly">YEARLY (15% DISCOUNT)</TabsTrigger> */}
      </div>
      <TabsContent value="monthly">
        <PlanFeatures />
        {/* {
          <div
            className={cn({
              'grid grid-cols-3 gap-[1px] rounded-jen-spacing-8  overflow-hidden bg-jen-border border-jen-border border  w-full h-full':
                !isMobileOrPad,
              '': isMobileOrPad,
            })}
          >
            {planList?.map(({ key, icon, name, price, button, desc }) => {
              return (
                <ChargeItem
                  key={key}
                  icon={icon}
                  name={name}
                  price={price}
                  button={button}
                  desc={desc}
                />
              );
            })}
          </div>
        } */}
      </TabsContent>
      <TabsContent value="yearly">
        123
        {/* <div className="grid grid-cols-3 gap-[1px] rounded-jen-spacing-8  overflow-hidden bg-jen-border border-jen-border border  w-full h-full">
          {planList?.map(({ key, icon, name, price, button, desc }) => {
            return (
              <ChargeItem
                key={key}
                icon={icon}
                name={name}
                price={price}
                button={button}
                desc={desc}
              />
            );
          })}
        </div> */}
      </TabsContent>
    </div>
  );
};

export default ChargeTabs;

interface ChargeItemProps {
  icon: React.ReactNode;
  name: string;
  price: string;
  button: React.ReactNode;
  desc: string[];
}

const ChargeItem: React.FC<ChargeItemProps> = ({
  icon,
  name,
  price,
  button,
  desc,
}) => {
  return (
    <div className="bg-jen-background-primary p-jen-spacing-24 rounded-2xl lg:rounded-none mb-[12px] lg:mb-0">
      {icon}
      <div className="mt-jen-spacing-32 text-jen-size-heading-02">{name}</div>
      <div className="mt-jen-spacing-8 text-jen-size-heading-04 text-jen-content-secondary">
        {price}
      </div>
      {button}
      <div className="mt-[132px] text-jen-content-secondary text-[16px] leading-none flex flex-col gap-jen-spacing-16">
        {desc.map((info) => {
          return (
            <div className="flex gap-[8px]" key={info}>
              <CheckFilledIcon className="flex-shrink-0 w-[16px] h-[16px]" />
              {info}
            </div>
          );
        })}
      </div>
    </div>
  );
};
